export default __webpack_public_path__ + "static/media/enable-sound.00d0be95.mp3";